import { SystemAlertSeverity } from '@app/types';
import BaseObject from './BaseObject';

// These are alerts that we display in the Udo Menu or as a dismissable alert in the bottom right of the UI
export const alertColorMap: { [K in SystemAlertSeverity]: string } = {
  low: '#2686BE',
  medium: '#FFBD27',
  high: '#EB515B',
};

export type DisplayLocation = 'menu' | 'banner';

export default class SystemAlert extends BaseObject {
  isDismissed: boolean;
  displayIn: DisplayLocation[];
  label: string;
  message: string;
  publishedAt: string;
  severity: SystemAlertSeverity;
  url: string;

  constructor(props: any = {}) {
    super(props);

    this.isDismissed = !!props.isDismissed;
    this.displayIn = props.displayIn;
    this.label = props.label;
    this.message = props.message;
    this.publishedAt = props.publishedAt;
    this.severity = props.severity;
    this.url = props.url;
  }
}
